// Optional localStorage override for testing old/new sidenav (dev/support).
// localStorage.override_new_sidenav = '1' forces new, '0' forces old,
// removing the key falls back to the account customization value.
export function resolveUseNewSidenav(accountValue) {
	const override = window.localStorage.getItem('override_new_sidenav');
	if (override === '0' || override === 'false') return false;
	if (override === '1' || override === 'true') return true;
	return !!accountValue;
}
